import {
    CREATE_DEFAULT_STYLE_MASTER_FAILURE,
    CREATE_DEFAULT_STYLE_MASTER_REQUEST,
    CREATE_DEFAULT_STYLE_MASTER_SUCCESS,
    CREATE_USER_FORM_DEFAULT_STYLE_MASTER,
    DELETE_DEFAULT_STYLE_MASTER_FAILURE,
    DELETE_DEFAULT_STYLE_MASTER_REQUEST,
    DELETE_DEFAULT_STYLE_MASTER_SUCCESS,
    FETCH_DEFAULT_STYLE_MASTER_FAILURE,
    FETCH_DEFAULT_STYLE_MASTER_REQUEST,
    FETCH_DEFAULT_STYLE_MASTER_SUCCESS,
    FETCH_SINGLE_DEFAULT_STYLE_MASTER_FAILURE,
    FETCH_SINGLE_DEFAULT_STYLE_MASTER_REQUEST,
    FETCH_SINGLE_DEFAULT_STYLE_MASTER_SUCCESS,
    RESET_DEFAULT_STYLE_MASTER_USER_FORM,
    TYPES_OF_MATERIALS_FAILURE,
    TYPES_OF_MATERIALS_REQUEST,
    TYPES_OF_MATERIALS_SUCCESS,
    UPDATE_DEFAULT_STYLE_MASTER_FAILURE,
    UPDATE_DEFAULT_STYLE_MASTER_REQUEST,
    UPDATE_DEFAULT_STYLE_MASTER_SUCCESS
} from './defaultStyleMaster.actionsType';

export const DEFAULT_STYLE_MASTER = 'defaultStyleMaster';

let initialState = {
    loading: false,
    defaultStyleMaster: [],
    sleeveTypeList: null,
    neckTypeList: null,
    typeOfFitList: null,
    yarnList: null,
    fabricTypeList: null,
    userform: {},
    selectedDefaultStyle: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let defaultStyleMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_DEFAULT_STYLE_MASTER_REQUEST:
        case TYPES_OF_MATERIALS_REQUEST:
        case CREATE_DEFAULT_STYLE_MASTER_REQUEST:
        case FETCH_SINGLE_DEFAULT_STYLE_MASTER_REQUEST:
        case UPDATE_DEFAULT_STYLE_MASTER_REQUEST:
        case DELETE_DEFAULT_STYLE_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_DEFAULT_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                defaultStyleMaster: updatePayload
            };
        case RESET_DEFAULT_STYLE_MASTER_USER_FORM:
            return {
                ...state,
                sleeveTypeList: null,
                neckTypeList: null,
                typeOfFitList: null,
                yarnList: null,
                fabricTypeList: null,
                selectedDefaultStyle: {},
                userform: {}
            };
        case TYPES_OF_MATERIALS_SUCCESS:
            if (payload == 19) {
                return {
                    ...state,
                    loading: false,
                    sleeveTypeList: updatePayload
                };
            } else if (payload == 11) {
                return {
                    ...state,
                    loading: false,
                    neckTypeList: updatePayload
                };
            } else if (payload == 20) {
                return {
                    ...state,
                    loading: false,
                    typeOfFitList: updatePayload
                };
            } else if (payload == 15) {
                return {
                    ...state,
                    loading: false,
                    yarnList: updatePayload
                };
            } else if (payload == 17) {
                return {
                    ...state,
                    loading: false,
                    fabricTypeList: updatePayload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case CREATE_DEFAULT_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_DEFAULT_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedArea: updatePayload,
                userform: updatePayload
            };
        case UPDATE_DEFAULT_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                sleeveTypeList: null,
                neckTypeList: null,
                typeOfFitList: null,
                yarnList: null,
                fabricTypeList: null,
                selectedDefaultStyle: {},
                userform: {}
            };
        case DELETE_DEFAULT_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                sleeveTypeList: null,
                neckTypeList: null,
                typeOfFitList: null,
                yarnList: null,
                fabricTypeList: null,
                selectedDefaultStyle: {},
                userform: {}
            };
        case FETCH_DEFAULT_STYLE_MASTER_FAILURE:
        case TYPES_OF_MATERIALS_FAILURE:
        case CREATE_DEFAULT_STYLE_MASTER_FAILURE:
        case FETCH_SINGLE_DEFAULT_STYLE_MASTER_FAILURE:
        case UPDATE_DEFAULT_STYLE_MASTER_FAILURE:
        case DELETE_DEFAULT_STYLE_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_DEFAULT_STYLE_MASTER:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        default:
            return state;
    }
};
